import React from 'react'

const CheckboxWrapper = React.forwardRef((props, ref) => (
  <label className='game-form-label-checkbox'>
    <div>{props.label}</div>
    <input type='checkbox' {...props} ref={ref} />
  </label>
))

export default CheckboxWrapper
